<mat-card class="shadow-none p-8 m-b-0">
  <mat-card-title class="title m-b-8">
    <span>{{ "change password" | translate }}</span>
    <span (click)="closeDialog()">
      <i-tabler name="x" class="icon-20 d-flex cursor-pointer" />
    </span>
  </mat-card-title>
  <mat-card-content class="p-0">
    <app-dynamic-form [formConfigs]="formConfigs"
                      [formGroup]="changePasswordForm"
                      [onSubmit]="onSubmit"
                      [spinLoader]="spinLoader">
    </app-dynamic-form>
  </mat-card-content>
</mat-card>
